import { render, staticRenderFns } from "./IconExclamation.vue?vue&type=template&id=2977fafc&"
import script from "./IconExclamation.vue?vue&type=script&lang=js&"
export * from "./IconExclamation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports